const BREAKPOINTS = {
  xs: "@media (max-width: 320px)", // below mobile
  sm: "@media (max-width: 480px)", // Mobile : 320px ~ 480px
  md: "@media (max-width: 768px)", // iPads, Tablets : 481px ~ 768px
  lg: "@media (max-width: 1024px)", // Small screens, laptops : 769px ~ 1024px
  xl: "@media (min-width: 1025px)", // Desktops, large screens : 1025px ~
};

export default BREAKPOINTS;
